import "core-js/modules/es.array.push.js";
import CoreComponent from '../../core/CoreComponent.vue';
import Cart from './cart.vue';
import Checkout from './checkout/checkout.vue';
import CreditCardPayment from './payment/credit-card-payment.vue';
import Confirmation from './confirmation/confirmation.vue';
const routes = [{
  path: '/view',
  component: Cart,
  name: 'cart'
}, {
  path: '/checkout',
  component: Checkout,
  name: 'checkout'
}, {
  path: '/payment',
  component: CreditCardPayment,
  name: 'payment'
}, {
  path: '/confirmation',
  component: Confirmation,
  name: 'confirmation'
}];
export default {
  name: 'PurchaseCart',
  extends: CoreComponent,
  components: {
    Cart,
    Checkout,
    CreditCardPayment,
    Confirmation
  },
  created() {
    routes.forEach(route => this.$router.addRoute(route));
  },
  mounted() {
    let hash = window.location.hash.substring(1);
    if (hash !== '/') {
      this.$router.push({
        path: hash
      });
    } else if (hash == '/') {
      this.$router.push({
        name: 'cart'
      });
    }
    this.$router.beforeEach(checkPath);
  }
};
function checkPath(to, from) {
  let hasToMatch = routes.some(route => route.path == to.path);
  if (!hasToMatch && to.path !== '/') {
    window.location.href = window.location.pathname;
  }
}